import useMediaQuery from 'Hooks/useMediaQuery';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

export function BreakPointHooks() {
    return {
        useGreater: (k: keyof typeof tailwindBreakpoints) =>
            useMediaQuery(`(min-width: ${tailwindBreakpoints[k]})`),
        useSmaller: (k: keyof typeof tailwindBreakpoints) =>
            useMediaQuery(`(max-width: ${tailwindBreakpoints[k]})`),
        useBetween: (
            a: keyof typeof tailwindBreakpoints,
            b: keyof typeof tailwindBreakpoints
        ) =>
            useMediaQuery(
                `(min-width: ${tailwindBreakpoints[a]}) and (max-width: ${tailwindBreakpoints[b]})`
            ),
    };
}
